import { Shark, SmartModel } from "shark-mvc";

class ProductLine extends SmartModel {
	constructor(data) {
		super();
		this.guid = "";
		this.name = "";
		this.status = 0;

		if (data) {
			this.import(data);
		}
	}
}

Shark.registerModel("ProductLine", ProductLine);

export default ProductLine;